export default "__VITE_ASSET__T6lUxua4__"